import calendar from "./calendar";
import client from "./client";
import document from "./document";
import invoices from "./invoices";
import patient from "./patient";

export default [
    {
        path: "/",
        name: "maria-bucci",
        meta: { auth: true },
        component: require("../views/MariaBucci.vue").default,
        children: [
            {
                path: "/profile",
                name: "profile",
                component: require("../components/profile/Profile.vue").default,
            },
        ]
            .concat(calendar)
            .concat(client)
            .concat(document)
            .concat(invoices)
            .concat(patient),
    },
];
